import { http } from '../../config/axios'

export interface FaturaMesDTO {
  mes: string
  quantidadePago: number
  quantidadeVencido: number
  valorPago: string
  valorVencido: string
}

export interface AtrasoDTO {
  numero: string
  dataVencimento: string
  dataPagamento: string | null
  diasAtraso: number
  valor: string
  status: string
}

export interface ConsultaOpcaoSerieDTO {
  opcao: string
  quantidades: number[]
}

export interface SaudeFinanceiraDTO {
  clienteId: string
  clienteNome: string
  clienteDocumento: string
  clienteInativo: boolean
  totalFaturas: number
  quantidadePago: number
  quantidadePagoEmDia: number
  quantidadePagoEmAtraso: number
  quantidadeVencido: number
  quantidadeRecebivel: number
  quantidadeIncobravel: number
  quantidadeEmAberto: number
  valorTotalFaturas: string
  valorTotalPago: string
  valorTotalVencido: string
  valorTotalRecebivel: string
  valorTotalIncobravel: string
  percentualPontualidade: number
  percentualInadimplencia: number
  rentabilidade: number
  mediaAtrasoEmDias: number
  scoreFinanceiro: number
  historico12Meses: FaturaMesDTO[]
  historicoAtrasos: AtrasoDTO[]
  consultasPorOpcao12Meses: ConsultaOpcaoSerieDTO[]
}

const getFaturaSaudeFinanceiraService = (idFatura: string): Promise<SaudeFinanceiraDTO> => {
  return http
    .get(`api/fatura/saude-financeira/${idFatura}`)
    .then((res) => res.data as SaudeFinanceiraDTO)
    .catch((error) => {
      console.error('Erro getFaturaSaudeFinanceira', error)
      throw Error(error.response?.data)
    })
}

export default getFaturaSaudeFinanceiraService
